// extracted by mini-css-extract-plugin
export default {"productDescription":"P--z","featuredDescription":"Q--z","description":"R--z","more":"S--z","descriptionSku":"T--z"};